// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_J1Xe5 {
  display: flex;
  flex-direction: column;
  gap: var(--size-padLarge);
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/screens/ConfirmRecovrSale.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-padLarge);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_J1Xe5`
};
export default ___CSS_LOADER_EXPORT___;
